import React from 'react';
import { Section, Divider } from './ui/Section';
import { motion } from 'framer-motion';
export function LeadSection() {
  return <div className="bg-dark-800/30 pb-0 md:pb-12" data-id="element-132">
      <Section data-id="element-133">
        <div className="max-w-3xl mx-auto text-center" data-id="element-134">
          <p className="text-xl md:text-3xl font-serif text-cream-100 mb-6 md:mb-10 leading-relaxed" data-id="element-135">
            Hubo una época en la que Venezuela era futuro.
            <br data-id="element-136" />
            Después fue incertidumbre.
            <br data-id="element-137" />
            Después miedo.
            <br data-id="element-138" />
            Después silencio.
          </p>

          <p className="text-2xl md:text-4xl font-serif font-bold text-gold-400 mb-6 md:mb-10 leading-tight" data-id="element-139">
            Y ahora pasa algo aún más peligroso:
          </p>

          <div className="prose prose-invert prose-lg text-cream-200 mx-auto" data-id="element-140">
            <div className="bg-dark-800 p-5 md:p-8 border-l-4 my-6 md:my-10 text-left" style={{
            borderLeftColor: '#1f40af'
          }} data-id="element-141">
              <p className="text-lg md:text-xl text-cream-100 font-medium leading-relaxed" data-id="element-142">
                Están reescribiendo lo que pasó.
              </p>
              <p className="text-lg md:text-xl text-cream-100 font-medium leading-relaxed mt-3" data-id="element-143">
                Lo están simplificando. Lo están maquillando. Lo están
                acomodando.
              </p>
            </div>

            <p className="text-lg md:text-2xl font-serif font-bold text-cream-100 mt-6 md:mt-10" data-id="element-144">
              Y si no dejamos registro claro… la próxima generación solo
              escuchará <span className="text-white" data-id="element-145">versiones editadas</span>.
            </p>

            <Divider data-id="element-146" />

            <div className="text-center mt-6 md:mt-12" data-id="element-147">
              <p className="text-2xl font-serif text-white mb-4" data-id="element-148">
                Este libro no es para discutir.
              </p>
              <p className="text-cream-200 text-[18px] font-[700]" data-id="element-149">
                Es para <span className="text-yellow-400" data-id="element-150">recordar</span> con
                estructura. Es para{' '}
                <span className="text-[#1f40af]" data-id="element-151">ordenar</span> lo que vivimos.
                <br data-id="element-152" />
                Es para que nadie pueda{' '}
                <span className="text-red-500" data-id="element-153">explicarlo</span> por nosotros.
              </p>
              <p className="text-cream-100 font-bold mt-6 text-lg md:text-xl font-serif leading-relaxed" data-id="element-154">
                Porque cuando no entiendes el proceso completo…
                <br data-id="element-155" />
                <span className="text-white" data-id="element-156">
                  te venden el mismo ciclo con otro nombre.
                </span>
              </p>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}